export const hourKey = [
  { value: 'monday', viewValue: 'Mon' },
  { value: 'tuesday', viewValue: 'Tue' },
  { value: 'wednesday', viewValue: 'Wed' },
  { value: 'thursday', viewValue: 'Thu' },
  { value: 'friday', viewValue: 'Fri' },
  { value: 'saturday', viewValue: 'Sat' },
  { value: 'sunday', viewValue: 'Sun' },
];
